export default "__VITE_ASSET__B7elnlO0__"